const DOCUMENTS = [
  "agent_info.pdf",
  "prospectus.pdf",
  "investment.pdf",
  "general.pdf",
  "termsFinproAG.pdf",
  "termsEffecta.pdf",
  "revocation.pdf",
];

const DOCUMENTS_PATH = "/files/";

export enum DocumentType {
  AgentInfo = 0,
  Prospectus,
  Investment,
  General,
  TermsFinproAG,
  TermsEffecta,
  Revocation,
}

export enum ShowFile {
  Open = 0,
  Download,
}

export const showFile = (view: ShowFile, fileType: DocumentType): void => {
  let documentName = DOCUMENTS[fileType];

  fetch(window.location.origin + DOCUMENTS_PATH + documentName)
    .then((resp) => resp.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;

      if (view === ShowFile.Download) {
        a.download = documentName;
      } else {
        a.target = "_blank";
      }

      a.onload = () => {
        window.URL.revokeObjectURL(url);
      };

      document.body.appendChild(a);
      a.click();
    })
    .catch(() => console.error("could not download the requested file"));
};
